import CardsSection, { CardsSectionProps } from "./CardsSection";

export { CardsSection as CardsSection, CardsSectionProps as CardsSectionProps };

export default CardsSection;
